import { css } from "styled-components";

export const transitionHoverStyles = (...properties: string[]) => {
    const _properties = properties.length ? properties : ["all"];

    return css`
        transition: ${props =>
            _properties.map(x => `${x} ${props.theme.transition.duration.short}ms ease-out`).join(", ")};
    `;
};
